module.exports = __webpack_public_path__ + "static/media/ig-icon.d21aa958.svg";